<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/position/detail/'+id}">职位列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               label-width="80px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-form-item prop="release_time"
                        label="发布时间:">
            {{form.up_date}}~{{form.down_date}}
          </el-form-item>
          <el-form-item label="行业大类:">
            <span v-for="industryType in options.industry_type"
                  v-if="industryType.id === form.industry_type">
              {{industryType.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="职位类型:">
            <span v-for="positionType in options.position_type"
                  v-if="positionType.id === form.position_type">
              {{positionType.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="岗位名称:">{{form.title}}</el-form-item>
          <el-form-item label="招聘人数:">{{form.hire_number}}</el-form-item>
          <el-form-item label="工作地点:">{{form.province_name}}-{{form.city_name}}-{{form.area_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{form.address}}
          </el-form-item>
          <el-form-item label="发布单位:">{{form.employer_name}}</el-form-item>
        </el-row>
        <br>
        <el-row class="text item">
          <el-col :span="24">
            <h2>职位描述</h2>
            <hr>
          </el-col>
          <el-form-item label="工作时间:">{{form.position_period}}</el-form-item>
          <el-form-item label="工作班次:">{{form.working_shifts}}</el-form-item>
          <el-form-item label="工作时长:">{{form.working_hours}}</el-form-item>
          <el-form-item label="性别要求:">
            <span v-for="gender in options.gender"
                  v-if="gender.id === form.gender">
              {{gender.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="年龄要求:">{{form.age_range}}</el-form-item>
          <el-form-item label="证件要求:">{{form.certificate}}</el-form-item>
          <el-form-item label="学历要求:">
            <span v-for="education in options.education"
                  v-if="education.id === form.education">
              {{education.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="婚姻状况:">
            <span v-for="marriage in options.marriage"
                  v-if="marriage.id === form.marriage">
              {{marriage.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="工作经验:">{{form.working_experience}}</el-form-item>
          <el-form-item label="补充说明:">{{form.other_requirements}}</el-form-item>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>薪资福利</h2>
            <hr>
          </el-col>
          <el-form-item label="基本薪资:">
            <span v-for="salary in options.salary"
                  v-if="salary.id === form.salary">{{salary.keyword}}</span>
            <span v-for="salaryType in options.salary_type"
                  v-if="salaryType.id === form.salary_type">
              {{salaryType.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="提成机制:">{{form.commission}}</el-form-item>
          <el-form-item label="季度奖金:">{{form.quarterly_bonus}}</el-form-item>
          <el-form-item label="社保缴纳:">
            <span v-for="insurance in options.insurance"
                  v-if="insurance.id === form.insurance">
              {{insurance.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="加班补助:">{{form.overtime_pay}}</el-form-item>
          <el-form-item label="餐饮补助:">{{form.meal_allowance}}</el-form-item>
          <el-form-item label="交通补助:">{{form.commute_allowance}}</el-form-item>
          <el-form-item label="话费补助:">{{form.phone_allowance}}</el-form-item>
          <el-form-item label="其他福利:">{{form.welfare}}</el-form-item>
          <el-form-item label="结算方式:">
            <span v-for="settlementType in options.settlement_type"
                  v-if="settlementType.id === form.settlement_type">
              {{settlementType.keyword}}
            </span>
          </el-form-item>
          <el-form-item label="结算时间:">
            <span v-for="settlementTime in options.settlement_time"
                  v-if="settlementTime.id === form.settlement_time">
              {{settlementTime.keyword}}
            </span>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row style="text-align:center">
        <Br/>
        <router-link :to="{ path: '/position/update/'+id}"
                     v-if="form.status === 0 || form.status === 2">
          <el-button type="primary">修改</el-button>
        </router-link>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <router-link :to="{ path: '/position/table'}">
          <el-button>返回</el-button>
        </router-link>
      </el-row>
    </layout-panel>

  </div>
</template>

<script>
export default {
  data () {
    return {
      id: this.$route.params.id,
      // searchRules,
      form: {
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null,
      },
      options: {
        industry_type: [],
        position_type: [],
        salary: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getPostionForm', this.id),
      request('editPostionOptions'),
    ]).then(([postionForm, postionOptions]) => {
      ((data) => {
        filter.setLoop(this.form, data.data)
      })(postionForm)

      ;((data) => {
        filter.setLoop(this.options, data.data)
      })(postionOptions)
    })
  },
  methods: {
    ...Vuex.mapActions(['getPostionForm', 'editPostionOptions']),

  },
}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionDetail.vue